export const WIDGET_TYPE = {
    GRAPH: 'graph',
    STATE: 'state',
    SUMMARY: 'summary',
    ALARM: 'alarm',
    GPS: 'gps',
    EV_GPS: 'ev-gps',
    VE: 've',
    SUMMARY_GRAPH: 'summary-graph',
    CUSTOM: 'custom',
};

export const WIDGET_CODE_TO_TYPE = {
    AcInputFrequency: WIDGET_TYPE.GRAPH,
    AcInputPower: WIDGET_TYPE.GRAPH,
    AcInputVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    SolarChargerVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    AcOutputFrequency: WIDGET_TYPE.GRAPH,
    AcOutputPower: WIDGET_TYPE.GRAPH,
    AcOutputVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    BatterySoc: WIDGET_TYPE.GRAPH,
    SystemBatterySoc: WIDGET_TYPE.GRAPH,
    SystemCriticalLoads: WIDGET_TYPE.GRAPH,
    BatteryTemperature: WIDGET_TYPE.GRAPH,
    InternalTemperature: WIDGET_TYPE.GRAPH,
    BatteryTemperatureVeBus: WIDGET_TYPE.GRAPH,
    BatteryTemperatureSolarCharger: WIDGET_TYPE.GRAPH,
    BatteryVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    BatteryMonitorWarningsAndAlarms: WIDGET_TYPE.STATE,
    SystemBatteryVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    InverterOutputVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    DcVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    IOExtenderTemperature: WIDGET_TYPE.GRAPH,
    MotorAndControllerTemperature: WIDGET_TYPE.GRAPH,
    MotorRPMAndControllerPower: WIDGET_TYPE.GRAPH,
    PVInverterYield: WIDGET_TYPE.GRAPH,
    SolarChargerPVYield: WIDGET_TYPE.GRAPH,
    SolarIrradiance: WIDGET_TYPE.GRAPH,
    StarterBatteryVoltage: WIDGET_TYPE.GRAPH,
    SystemAcConsumption: WIDGET_TYPE.GRAPH,
    SystemAcGenset: WIDGET_TYPE.GRAPH,
    SystemGrid: WIDGET_TYPE.GRAPH,
    SignalRSSI: WIDGET_TYPE.GRAPH,
    VeBusSoc: WIDGET_TYPE.GRAPH,
    VeBusWarningsAndAlarms: WIDGET_TYPE.STATE,
    VeBusState: WIDGET_TYPE.STATE,
    MPPTState: WIDGET_TYPE.STATE,
    InverterState: WIDGET_TYPE.STATE,
    InputState: WIDGET_TYPE.STATE,
    GeneratorState: WIDGET_TYPE.STATE,
    ChargerState: WIDGET_TYPE.STATE,
    BatteryRelayState: WIDGET_TYPE.STATE,
    BatteryExternalRelayState: WIDGET_TYPE.STATE,
    ChargerRelayState: WIDGET_TYPE.STATE,
    GatewayRelayState: WIDGET_TYPE.STATE,
    GatewayRelayTwoState: WIDGET_TYPE.STATE,
    SolarChargerRelayState: WIDGET_TYPE.STATE,
    BatterySummary: WIDGET_TYPE.SUMMARY,
    BMSDiagnostics: WIDGET_TYPE.SUMMARY,
    HistoricData: WIDGET_TYPE.SUMMARY,
    IOExtenderInOut: WIDGET_TYPE.SUMMARY,
    LithiumBMS: WIDGET_TYPE.SUMMARY,
    MotorSummary: WIDGET_TYPE.SUMMARY,
    PVInverterStatus: WIDGET_TYPE.SUMMARY,
    SolarChargerSummary: WIDGET_TYPE.SUMMARY,
    TankSummary: WIDGET_TYPE.SUMMARY,
    Status: WIDGET_TYPE.SUMMARY,
    Alarm: WIDGET_TYPE.ALARM,
    GPSWidget: WIDGET_TYPE.GPS,
    EvGPSWidget: WIDGET_TYPE.EV_GPS,
    EvSoc: WIDGET_TYPE.GRAPH,
    EvState: WIDGET_TYPE.STATE,
    VeConfigure: WIDGET_TYPE.VE,
    SystemBatteryPower: WIDGET_TYPE.GRAPH,
    TempSummary: WIDGET_TYPE.SUMMARY,
    InputSummary: WIDGET_TYPE.SUMMARY,
    TempGraph: WIDGET_TYPE.GRAPH,
    TempSummaryAndGraph: WIDGET_TYPE.SUMMARY_GRAPH,
    DCMeter: WIDGET_TYPE.SUMMARY_GRAPH,
    SystemDcSystem: WIDGET_TYPE.GRAPH,
    SolarChargerLoadoutputCurrent: WIDGET_TYPE.GRAPH,
    SystemPVYield: WIDGET_TYPE.GRAPH,
    TankLevel: WIDGET_TYPE.GRAPH,
    BMSChargeAndDischargeLimits: WIDGET_TYPE.GRAPH,
    SolarChargerPVVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    SolarChargerPVVoltageAndCurrentTracker1: WIDGET_TYPE.GRAPH,
    SolarChargerPVVoltageAndCurrentTracker2: WIDGET_TYPE.GRAPH,
    SolarChargerPVVoltageAndCurrentTracker3: WIDGET_TYPE.GRAPH,
    SolarChargerPVVoltageAndCurrentTracker4: WIDGET_TYPE.GRAPH,
    ChargerOutputVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    ChargerAcCurrent: WIDGET_TYPE.GRAPH,
    ChargerAcPower: WIDGET_TYPE.GRAPH,
    BatteryMidVoltage: WIDGET_TYPE.GRAPH,
    MeteorologicalSensor: WIDGET_TYPE.SUMMARY_GRAPH,
    GlobalLinkSummary: WIDGET_TYPE.SUMMARY_GRAPH,
    FuelCellState: WIDGET_TYPE.STATE,
    FuelCellBusStatus: WIDGET_TYPE.GRAPH,
    FuelCellPower: WIDGET_TYPE.GRAPH,
    FuelCellFlows: WIDGET_TYPE.GRAPH,
    FuelCellTemperatures: WIDGET_TYPE.GRAPH,
    EssBatteryLifeState: WIDGET_TYPE.STATE,
    PulseMeterAggregate: WIDGET_TYPE.GRAPH,
    BatteryCellMinMax: WIDGET_TYPE.GRAPH,
    BatteryCellTemperatureMinMax: WIDGET_TYPE.GRAPH,
    BatteryConsumedAmphours: WIDGET_TYPE.GRAPH,
    EvChargerPower: WIDGET_TYPE.GRAPH,
    EvChargerSummary: WIDGET_TYPE.SUMMARY,
    GridMeterSummary: WIDGET_TYPE.SUMMARY,
    GridMeterEnergySummary: WIDGET_TYPE.SUMMARY,
    PvInverterSummary: WIDGET_TYPE.SUMMARY,
    PvInverterEnergySummary: WIDGET_TYPE.SUMMARY,
    AcMeterSummary: WIDGET_TYPE.SUMMARY,
    AcMeterEnergySummary: WIDGET_TYPE.SUMMARY,
    AlternatorTemperature: WIDGET_TYPE.GRAPH,
    AlternatorVoltage: WIDGET_TYPE.GRAPH,
    AlternatorCurrent: WIDGET_TYPE.GRAPH,
    AlternatorSpeedAndDrive: WIDGET_TYPE.GRAPH,
    AlternatorState: WIDGET_TYPE.STATE,
    AlternatorInputVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    AlternatorOutputVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    AlternatorInputPower: WIDGET_TYPE.GRAPH,
    AlternatorOutputPower: WIDGET_TYPE.GRAPH,
    DcLoadCurrent: WIDGET_TYPE.GRAPH,
    DcLoadPower: WIDGET_TYPE.GRAPH,
    AcMeterPower: WIDGET_TYPE.GRAPH,
    GridMeterPower: WIDGET_TYPE.GRAPH,
    TemperatureSensorHumidity: WIDGET_TYPE.GRAPH,
    TemperatureSensorPressure: WIDGET_TYPE.GRAPH,
    InverterChargerPVPower: WIDGET_TYPE.GRAPH,
    InverterChargerPVVoltage: WIDGET_TYPE.GRAPH,
    InverterChargerBatteryVoltage: WIDGET_TYPE.GRAPH,
    InverterChargerBatteryVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    InverterChargerDCCurrent: WIDGET_TYPE.GRAPH,
    InverterChargerACOutputVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    InverterChargerACInputVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    InverterChargerAcOutputPower: WIDGET_TYPE.GRAPH,
    InverterChargerAcOutputFrequency: WIDGET_TYPE.GRAPH,
    InverterChargerAcInputPower: WIDGET_TYPE.GRAPH,
    InverterChargerAcInputFrequency: WIDGET_TYPE.GRAPH,
    InverterChargerBatterySoc: WIDGET_TYPE.GRAPH,
    InverterChargerRelayState: WIDGET_TYPE.STATE,
    InverterChargerState: WIDGET_TYPE.STATE,
    InverterChargerWarningsAndAlarms: WIDGET_TYPE.STATE,
    InverterRSSolarPVPower: WIDGET_TYPE.GRAPH,
    InverterRSSolarPVVoltage: WIDGET_TYPE.GRAPH,
    InverterRSSolarBatteryVoltage: WIDGET_TYPE.GRAPH,
    InverterRSSolarDCCurrent: WIDGET_TYPE.GRAPH,
    InverterRSSolarAcOutputPower: WIDGET_TYPE.GRAPH,
    InverterRSSolarAcOutputFrequency: WIDGET_TYPE.GRAPH,
    InverterRSSolarBatterySoc: WIDGET_TYPE.GRAPH,
    InverterRSSolarRelayState: WIDGET_TYPE.STATE,
    InverterRSSolarWarningsAndAlarms: WIDGET_TYPE.STATE,
    DcDcConverterState: WIDGET_TYPE.STATE,
    SmartBatteryProtectState: WIDGET_TYPE.STATE,
    SmartLithiumBalancerState: WIDGET_TYPE.STATE,
    DcDcConverterInputVoltage: WIDGET_TYPE.GRAPH,
    DcDcConverterOutputVoltage: WIDGET_TYPE.GRAPH,
    DcDcConverterInputVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    DcDcConverterOutputVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    DcDcConverterInputPower: WIDGET_TYPE.GRAPH,
    DcDcConverterOutputPower: WIDGET_TYPE.GRAPH,
    SmartLithiumCellVoltages: WIDGET_TYPE.GRAPH,
    SmartLithiumBatteryVoltage: WIDGET_TYPE.GRAPH,
    SmartLithiumBatteryTemperature: WIDGET_TYPE.GRAPH,
    SmartBatteryProtectInputVoltage: WIDGET_TYPE.GRAPH,
    SmartBatteryProtectOutputVoltage: WIDGET_TYPE.GRAPH,
    GridMeterVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    GridMeterCombined: WIDGET_TYPE.GRAPH,
    PvInverterVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    PvInverterCombined: WIDGET_TYPE.GRAPH,
    AcMeterVoltageAndCurrent: WIDGET_TYPE.GRAPH,
    AcMeterCombined: WIDGET_TYPE.GRAPH,
    CustomWidget: WIDGET_TYPE.CUSTOM,
};
